var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookImportSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_236",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlook",
    transform: "translate(-650 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161004",
    "data-name": "Group 161004",
    transform: "translate(328 -68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 322, 356)",
    filter: "url(#Ellipse_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236-2",
    "data-name": "Ellipse 236",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(6 4)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Outlook-2",
    "data-name": "Outlook",
    transform: "translate(673.4 305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(7.818 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M54.627,9.228H34.2V5.974A.958.958,0,0,1,35.15,5h18.5a.963.963,0,0,1,.974.974Z",
    transform: "translate(-34.2 -5)",
    fill: "#0464b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1788",
    "data-name": "Rectangle 1788",
    width: 6.817,
    height: 6.318,
    transform: "translate(0 4.228)",
    fill: "#0377d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    width: 6.817,
    height: 6.318,
    transform: "translate(6.817 4.228)",
    fill: "#29a7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1790",
    "data-name": "Rectangle 1790",
    width: 6.817,
    height: 6.318,
    transform: "translate(13.634 4.228)",
    fill: "#4fd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 6.817,
    height: 6.318,
    transform: "translate(0 10.546)",
    fill: "#1681d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 6.817,
    height: 6.318,
    transform: "translate(6.817 10.546)",
    fill: "#0178d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 6.817,
    height: 6.318,
    transform: "translate(13.634 10.546)",
    fill: "#29a7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    width: 6.817,
    height: 6.318,
    transform: "translate(6.817 16.84)",
    fill: "#0464b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    width: 6.817,
    height: 6.318,
    transform: "translate(13.634 16.84)",
    fill: "#1681d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M121.868,63.534l-1.568.926V61.8l1.544.855A.5.5,0,0,1,121.868,63.534Z",
    transform: "translate(-92.031 -43.309)",
    fill: "#042071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M54.464,67.728l-.143.1h0l-.166.095-1.259.736V68.63l-21,12.019H53.063a1.617,1.617,0,0,0,1.615-1.615L54.7,67.3A.455.455,0,0,1,54.464,67.728Z",
    transform: "translate(-24.628 -47.503)",
    fill: "#168fde"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490",
    transform: "translate(5.871 20.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M48.8,81.564H27.615A1.617,1.617,0,0,1,26,79.948V68.5Z",
    transform: "translate(-26 -68.5)",
    fill: "#29a7eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M13.709,46.939H1.12A1.531,1.531,0,0,1-.4,45.419V33.02A1.531,1.531,0,0,1,1.12,31.5H13.709a1.531,1.531,0,0,1,1.52,1.52v12.4A1.515,1.515,0,0,1,13.709,46.939Z",
    transform: "translate(0 -20.206)",
    fill: "#1681d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491",
    transform: "translate(3.424 14.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M19.69,54.688c-2.446,0-3.99-1.853-3.99-4.323,0-2.613,1.686-4.465,4.109-4.465,2.518,0,3.99,1.876,3.99,4.3.024,2.874-1.734,4.489-4.109,4.489Zm.1-1.235c1.52,0,2.375-1.4,2.375-3.183,0-1.615-.808-3.111-2.375-3.111s-2.4,1.473-2.4,3.183.855,3.112,2.4,3.112Z",
    transform: "translate(-15.7 -45.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M35.382,37.3V49.841a1.531,1.531,0,0,1-1.52,1.52H26v1.354h9.121a1.531,1.531,0,0,0,1.52-1.52V38.8A1.492,1.492,0,0,0,35.382,37.3Z",
    transform: "translate(-20.129 -24.628)",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookImportSvg);
export default __webpack_public_path__ + "static/media/OutlookImportSvg.0ddfddb59a648271dcb60c34db9a821f.svg";
export { ForwardRef as ReactComponent };